import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { ActionContainer, CloseIconWrapper, StyledBaseDrawer, Title } from './BaseMobileDrawer.styles';
import { EPButton } from '@/components';
import { theme } from 'antd';
import { BaseMobileDrawerProps } from './BaseMobileDrawer.utils';
import { useTranslation } from 'react-i18next';

const BaseMobileDrawer: React.FC<BaseMobileDrawerProps> = ({
  isOpen,
  onClose,
  title,
  children,
  primaryButton,
  secondaryButton,
  isSubmitted,
}) => {
  const { useToken } = theme;
  const { token } = useToken();
  const { t } = useTranslation();

  const renderTitle = () => {
    if (typeof title === 'string') {
      return <Title>{isSubmitted ? title : `${t('ADD')} ${title.toLowerCase()}`}</Title>;
    }
    return title;
  };

  const renderFooter = () => {
    if (!primaryButton && !secondaryButton) return null;

    return (
      <ActionContainer>
        {primaryButton && (
          <EPButton
            type={primaryButton.variant === 'secondary' ? 'text' : 'primary'}
            onClick={primaryButton.onClick}
            disabled={primaryButton.disabled || isSubmitted}
          >
            {primaryButton.text}
          </EPButton>
        )}
        {secondaryButton && (
          <EPButton
            type="text"
            onClick={secondaryButton.onClick}
            style={{ color: token.colorPrimary }}
            disabled={secondaryButton.disabled || isSubmitted}
          >
            {secondaryButton.text}
          </EPButton>
        )}
      </ActionContainer>
    );
  };

  return (
    <StyledBaseDrawer
      className="custom-base-drawer"
      open={isOpen}
      onClose={onClose}
      placement="bottom"
      height="auto"
      closable={true}
      maskClosable={false}
      closeIcon={
        <CloseIconWrapper>
          <CloseOutlined />
        </CloseIconWrapper>
      }
    >
      <div className="drawer-content">
        <div className="base-drawer-header">{renderTitle()}</div>
        <div className="base-drawer-content-section">{children}</div>
        <div className="base-drawer-footer">{renderFooter()}</div>
      </div>
    </StyledBaseDrawer>
  );
};

export default BaseMobileDrawer;
